module.exports = __webpack_public_path__ + "img/fws.27aca2c5.svg";